import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rocket.svg'
import _imports_1 from '@/assets/images/photo.svg'
import _imports_2 from '@/assets/images/avatars.svg'
import _imports_3 from '@/assets/images/account.svg'
import _imports_4 from '@/assets/images/upscale.svg'
import _imports_5 from '@/assets/images/logout.svg'


const _withScopeId = n => (_pushScopeId("data-v-00df25ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-white flex flex-col h-screen min-w-[64px] fixed left-0 top-0 w-16 md:w-[190px] md:min-w-[190px] my_menu overflow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-row flex justify-center pt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-12 w-12 mylog rounded-2xl",
    src: _imports_0,
    alt: "Workflow"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-5 w-5 md:mr-6 md:ml-3",
  src: _imports_1,
  alt: "Workflow"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-line text-[14px] hidden md:flex" }, "Photos", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-5 w-5 md:mr-6 md:ml-3",
  src: _imports_2,
  alt: "Workflow"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-line text-[14px] hidden md:flex" }, "Avatars", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-5 w-5 md:mr-6 md:ml-3",
  src: _imports_3,
  alt: "Workflow"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-line text-[14px] hidden md:flex" }, "Account", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-5 w-5 md:mr-6 md:ml-3",
  src: _imports_4,
  alt: "Workflow"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-line text-[14px] hidden md:flex" }, "Upscale", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-5 w-5 md:mr-6 md:ml-3",
  src: _imports_5,
  alt: "Workflow"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-line text-[14px] hidden md:flex" }, "Logout", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["flex-row flex items-center mt-10 justify-center md:justify-start h-10 text-cool my_active mx-3 rounded cursor-pointer", {'myt' : _ctx.type == 'sources'}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nav('sources')))
    }, _hoisted_5, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-row flex items-center mt-2 justify-center md:justify-start h-10 text-cool my_active mx-3 rounded cursor-pointer", {'myt' : _ctx.type == 'avatars'}]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nav('avatars')))
    }, _hoisted_8, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-row flex items-center mt-2 justify-center md:justify-start h-10 text-cool my_active mx-3 rounded cursor-pointer", {'myt' : _ctx.type == 'account'}]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nav('account')))
    }, _hoisted_11, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-row flex items-center justify-center md:justify-start mt-8 h-10 opacity-70 text-cool my_active mx-3 rounded cursor-pointer", {'myt' : _ctx.type == 'upscale'}])
    }, _hoisted_14, 2),
    _hoisted_15,
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout())),
      class: _normalizeClass(["flex-row mb-10 flex justify-center md:justify-start items-center mt-8 h-10 opacity-70 text-cool my_active mx-3 rounded cursor-pointer", {'myt' : _ctx.type == 'upscale'}])
    }, _hoisted_18, 2)
  ]))
}